import React from 'react';

interface VisualCircleProps {
  width?: number;
  height?: number;
  selectedIndex: number | undefined;
  handleClick: (index: number | undefined) => unknown;
  divisions: { color: string; percentage: number }[];
}

const VisualCircle: React.FC<VisualCircleProps> = ({
  width = 218,
  height = 218,
  divisions,
  selectedIndex,
  handleClick,
}) => {
  if (divisions.length === 1) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 230 230"
        fill="none"
      >
        <path
          d="M115 224C54.801 224 6 175.199 6 115C6 54.801 54.801 6 115 6C175.199 6 224 54.801 224 115C224 175.199 175.199 224 115 224"
          stroke={divisions[0].color}
          stroke-width="12"
        />
      </svg>
    );
  }

  const radius = 100; // half of SVG size
  let startAngle = -90; // start from the top
  const gap = 0.5;

  return (
    <svg width={width} height={height}>
      {divisions.map((division, index) => {
        const { color, percentage } = division;
        const endAngle = startAngle + (percentage / 100) * 360 - gap;
        const largeArcFlag = percentage > 50 ? 1 : 0;

        const x1 = 109 + radius * Math.cos((Math.PI * startAngle) / 180);
        const y1 = 109 + radius * Math.sin((Math.PI * startAngle) / 180);
        const x2 = 109 + radius * Math.cos((Math.PI * endAngle) / 180);
        const y2 = 109 + radius * Math.sin((Math.PI * endAngle) / 180);
        const d = `M ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`;
        startAngle = endAngle + gap;

        const onClick = () =>
          handleClick(selectedIndex === index ? undefined : index);

        return (
          <path
            key={index}
            d={d}
            opacity={
              selectedIndex === undefined || selectedIndex === index ? 1 : 0.3
            }
            fill="transparent"
            stroke={color}
            stroke-width="12"
            onClick={onClick}
          />
        );
      })}
    </svg>
  );
};

export default VisualCircle;
